<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">地区名称</span>
        <el-dropdown trigger="click" placement="bottom-start">
          <input
            class="inputs"
            :value="areaName || '全部地区'"
            @input="changeAreaMsgName($event, 'areaName')"
            type="text"
            readonly
            style="
              color: #409eff;
              font-weight: 600;
              background: none;
              width: 100px;
            "
          />
          <el-dropdown-menu slot="dropdown" style="width: 160px">
            <div class="menu_box">
              <el-dropdown-item
                v-for="item in regionList"
                :key="item.id"
                @click.native="dropdownItem(item, 'conditions', 'areaName')"
                >{{ item.name || "全部地区" }}</el-dropdown-item
              >
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="fonints">流向名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.customerName"
          clearable
        >
        </el-input>
        <div class="cheboxSty">
          <span class="fonints">支付渠道</span>
          <el-radio-group v-model="conditions.paymentChannel">
            <el-radio :label="1">线上支付</el-radio>
            <el-radio :label="2">线下支付</el-radio>
          </el-radio-group>
        </div>
        <button class="buttons" @click="getFlowlist">查询</button>
      </div>
      <div class="componentSty_content_table" style="border:none">
        <el-table :data="flowlist.list" style="width: 100%; height: 80%" border height="80%">
           <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" width="100" prop="areaId" label="ID">
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="areaName" label="地区名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="customerCode" label="流向编码">
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="customerName" label="流向名称">
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="paymentChannel" label="付款渠道">
            <template v-slot="res">
              <span
                v-if="res.row.paymentChannel == 1"
                style="color: rgb(19, 209, 104)"
                >线上支付</span
              >
              <span v-if="res.row.paymentChannel == 2" style="color: blue"
                >线下支付</span
              >
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="memo" label="备注"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="操作">
            <template v-slot="res">
              <span
                class="iconfont icon-xiugai"
                @click="itemparticulars(res.row)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="flowlist.list && flowlist.list.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :current-page="conditions.page"
            :total="flowlist.totalCount"
            @current-change="getFlowlist"
          >
          </el-pagination>
        </div>
      </div>
      <m-dialog :isShow="addrole" @changeState="sendMsg" :title="title">
        <div class="inForMsgBox">
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="key" style="width: 21%">地区</span>
            <div class="val">
              <el-dropdown trigger="click" placement="bottom-start">
                <input
                  class="inputs"
                  :value="areaName2"
                  @input="changeAreaMsgName($event, 'areaName2')"
                  readonly
                  style="color: #409eff; font-weight: 600; background: none"
                />
                <el-dropdown-menu slot="dropdown" style="width: 160px">
                  <div class="menu_box">
                    <el-dropdown-item
                      v-for="item in regionList"
                      :key="item.id"
                      @click.native="dropdownItem(item, 'infoobj', 'areaName2')"
                      >{{ item.name }}</el-dropdown-item
                    >
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="fonints">支付渠道</span>
            <el-radio-group v-model="infoobj.paymentChannel">
              <el-radio :label="1">线上支付</el-radio>
              <el-radio :label="2">线下支付</el-radio>
            </el-radio-group>
          </div>
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="key" style="width: 21%">流向编码</span>
            <div class="val" style="background: #f3f4f5">
              <m-superIpt
                defaultInfo="请输入流向编码"
                v-model.lazy="infoobj.customerCode"
              ></m-superIpt>
            </div>
          </div>
          <div class="itemBox" style="width: 100%; line-height: 30px">
            <span class="key" style="width: 21%">流向名称</span>
            <div class="val" style="background: #f3f4f5">
              <m-superIpt
                defaultInfo="请输入流向名称"
                v-model="infoobj.customerName"
              ></m-superIpt>
            </div>
          </div>
          <div class="itemBox" style="width: 100%; height: 100px">
            <span class="key" style="width: 21%">备注</span>
            <div class="val" style="background: #f3f4f5">
              <textarea
                class="txtarea"
                placeholder="请填写备注"
                v-model="infoobj.memo"
              >
              </textarea>
            </div>
          </div>
        </div>
      </m-dialog>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mDialog from "@/components/mDialog";
import mSuperIpt from "@/components/mSuperIpt";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "统计分析" }, { name: "基础流向" }],
      addrole: false,
      conditions: {},
      title: "添加",
      areaName: "",
      areaName2: "",
      infoobj: {},
      areaMsg: {
        limit: 100,
        page: 1,
        name: null,
      },
      regionList: [],
      flowlist: {},
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
    mDialog,
    mSuperIpt,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: {
          page: 1,
          limit: 20,
          paymentChannel: 1,
        },
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      paymentChannel: 1,
    };
    this.areaName = this.conditions.areaName || "";
    this.getRegionList();
    this.getFlowlist();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getRegionList() {
      const { data } = await this.$http(
        "api1",
        "/sys/areaflow/getAreaListPc",
        "get",
        this.areaMsg
      );

      if (data.code != 0) return this.$message.error(data.msg);
      this.regionList = [{ id: null, name: "" }, ...data.data.list];
      if (!this.areaMsg.name) {
        this.infoobj.areaId = null;
        this.infoobj.areaName = null;
      }
    },
    async getFlowlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/externalservices/flow/flowlist",
        "get",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.flowlist = data.data;
    },
    async sendMsg(item) {
      if (item != "confirm") {
        return (this.addrole = false);
      }
      if (!this.infoobj.areaName) return this.$message.error("请选择地区");
      if (!this.infoobj.customerName || !this.infoobj.customerCode)
        return this.$message.error("必填项不能为空");
      const { data } = await this.$http(
        "api1",
        "/externalservices/flow/update",
        "post",
        this.infoobj
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.$message.success(`${this.title}成功`);
      this.getFlowlist();
      this.addrole = false;
    },
    itemparticulars(row) {
      this.title = "修改";
      this.addrole = true;
      this.infoobj = Object.assign({}, row);
      this.areaName2 = this.infoobj.areaName;
    },
    changeAreaMsgName(event, name) {
      this.areaMsg.name = this[name] = event.target.value.trim();
      this.getRegionList();
    },
    dropdownItem(item, obj, name) {
      this[obj].areaId = item.id;
      this[obj].areaName = this[name] = item.name;
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
<style scoped>
.txtarea {
  background: #f3f4f5;
  border: none;
  width: 100%;
  height: 100%;
  outline: none;
  resize: none;
}
</style>